// DS: i10.6
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Tumblr: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M10.297 3c-.104.917-.293 1.67-.568 2.263a4.836 4.836 0 0 1-1.092 1.524c-.455.423-.526.747-1.637.974v3.017h2.222v5.746c0 .812-.142 1.432.014 1.858.155.428.325.832.728 1.211.403.38.835.673 1.407.877.57.206 1.2.308 1.943.308.655 0 1.25-.072 1.813-.216.563-.143.762-.393 1.873-.75v-2.796c-1.111.585-1.633.877-2.457.877-.463 0-.875-.117-1.234-.354a1.36 1.36 0 0 1-.58-.7c-.1-.293-.173-.955-.173-1.986v-4.075H17V7.444h-4.444V3h-2.26z" />
      </g>
    </svg>
  </IconWrap>
);
Tumblr.displayName = 'Tumblr';

export default Tumblr;
